import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import { GenericPopup, ButtonTheme } from '@apply/components';

export interface GenericAlertProps {
    id?: string;
    children: any;
    title?: string;
    showCloseButton?: boolean;
    showTitle?: boolean;
    width?: string;
    height?: string;
    minHeight?: string;
    maxWidth?: string;
    maxHeight?: string;
    handleClose?: () => void;
}

export const GenericAlert: React.FC<GenericAlertProps> = ({
    id = 'genericAlertPopup',
    children,
    title = 'Alert',
    showCloseButton = true,
    showTitle = true,
    width = 'auto',
    height = 'auto',
    minHeight = 'auto',
    maxWidth = 'auto',
    maxHeight = 'auto',
    handleClose,
}) => {
    const onClose = useCallback(() => {
        handleClose && handleClose();
        removeModal();
    }, [handleClose]);

    const actionButtons = [
        {
            id: `${id}_okButton`,
            theme: ButtonTheme.Primary,
            disabled: false,
            children: 'Close',
            width: '120px',
            handleClick: onClose,
        },
    ];

    return (
        <>
            <GenericPopup
                id={id}
                isOpen={true}
                actionButtons={actionButtons}
                handleClose={onClose}
                aria-labelledby='alert-dialog-title'
                hideOnOutsideClick={false}
                showCloseButton={showCloseButton}
                showTitle={showTitle}
                title={title}
                width={width}
                height={height}
                minHeight={minHeight}
                maxWidth={maxWidth}
                maxHeight={maxHeight}
                buttonAlignment='right'
                wrapTitle={true}
            >
                <div style={{ paddingBottom: '20px' }}>{children}</div>
            </GenericPopup>
        </>
    );
};

const mountPointId = 'bfi-apply-generic-alert-modal';

// the ignore below are because really the branch being ignored is providing
// arguably over-zealous protection against throwing null-ref exceptions when something
// in the browser has just gone horribly wrong, but really can't be tested
const removeModal = () => {
    const mountPoint = document.getElementById(mountPointId);
    /* istanbul ignore else */
    if (mountPoint) {
        ReactDOM.unmountComponentAtNode(mountPoint);
        mountPoint.parentNode?.removeChild(mountPoint);
    }
};

export const GenericAlertPopup = (props: GenericAlertProps): void => {
    let mountPoint = document.getElementById(mountPointId);
    // istanbul ignore if
    if (mountPoint) {
        ReactDOM.render(<GenericAlert {...props} />, mountPoint);
    } else {
        mountPoint = document.createElement('div');
        mountPoint.id = mountPointId;
        document.body.appendChild(mountPoint);
        ReactDOM.render(<GenericAlert {...props} />, mountPoint);
    }
};
